<template>
  <div>

    <div v-if="authenticated">
      <HomeRegistered />
    </div>
    <div v-else>
      <HomeUnregistered />
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import HomeRegistered from '@/components/Home_unregistered'
import HomeUnregistered from '@/components/Home_unregistered'
export default {
  name: 'Home',
  computed: {
      ...mapGetters({
          authenticated: 'auth/authenticated',
          user: 'auth/user',

      })
  },
  components: {
    HomeRegistered,
    HomeUnregistered,
  }
}
</script>
